import { TipoIntervaloPeriodo } from 'core/features/area-comum/typings';
import { PessoaFisicaOuJuridicaForm } from 'resources/types/pessoa';

export interface ClienteItemResponse {
  id: string;
  nome: string;
  imagemUrl: string;
  estado: string;
  cidade: string;
  bairro: string;
  logradouro: string;
  ativo: boolean;
  novo: boolean;
  inadimplente: boolean;
  documento: string;
  tempoFimContrato: number;
}

export enum TipoContrato {
  Aluguel = "1",
  Venda = "2",
}
export interface ContratoClienteArquivo {
  id: string;
  nome: string;
  referencia: string;
  mimetype: string;
}
export interface ClienteContrato {
  id: string;
  matricula: string;
  nomeCorretor: string;
  assinatura: string;
  duracao: string;
  ativo: boolean;
  valor: number;
  multa: number;
  desconto: number;
  inadimplente: boolean;
  novo: boolean;
  contaAtraso: number;
  tempoFimContrato?: number;
  tipoContrato: TipoContrato;
  creci: string;
  taxaAtraso: number;
  regras: { id: string; texto: string }[];
  arquivos?: ContratoClienteArquivo[];
}

export enum ClienteSituacao {
  Adimplente = 'adimplente',
  Inadimplente = 'inadimplente',
  Novo = 'novo'
}
export interface ClientesQueryParams {
  search?: string;
  orderDirection?: string;
  orderBy?: string;
  documento?: string;
  situacao?: ClienteSituacao;
  tempoFimContrato?: number;
  tipoIntervaloTempoFimContrato?: TipoIntervaloPeriodo;
}

export interface ClienteDashboardResponse {
  total: number;
  ativos: number;
  inativos: number;
  contratosAtivos: number;
}

export interface ClienteGraficoAdimplenciaResponse {
  emDia: number;
  inadimplentes: number;
  pendentes: number;
}

export interface ClienteDetalheResponse  extends PessoaFisicaOuJuridicaForm {}